import { useState, useEffect, useRef } from "react";
import { Segment, Header } from "semantic-ui-react";

// Utils
import { parseBroadcastContent } from "./MeBroadcastUtils";

const MAX_LINES = 4;

const BroadcastPreview = ({ content }: { content: string }) => {
  const [images, setImages] = useState<string[]>([]);
  const [texts, setTexts] = useState<string>("");
  const [videos, setVideos] = useState<string[]>([]);
  const [isClamp, setIsClamp] = useState<boolean>(false);

  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!content) {
      setImages([]);
      setVideos([]);
      setTexts("");
      setIsClamp(false);
      return;
    };

    const wrapper = document.createElement("div");
    wrapper.innerHTML = content;

    // Images
    const imgs = Array.from(wrapper.querySelectorAll("img")).map(
      (img) => img.getAttribute("src") || ""
    );
    setImages(imgs);

    // Videos
    const iframes = Array.from(wrapper.querySelectorAll("iframe")).map(
      (iframe) => iframe.getAttribute("src") || ""
    );
    setVideos(iframes);

    // Texts
    wrapper
      .querySelectorAll("img, figure, .se-image-container, .se-video-container iframe")
      .forEach((el) => el.remove());
    // wrapper.querySelectorAll("img").forEach((img) => img.remove());
    // wrapper.querySelectorAll("figure").forEach((f) => f.remove());
    // wrapper.querySelectorAll(".se-image-container").forEach((c) => c.remove());

    setTexts(wrapper.innerText.trim());
  }, [content]);

  useEffect(() => {
    if (textRef.current) {
      const el = textRef.current;
      const isOverflow = el.scrollHeight > el.clientHeight;

      setIsClamp(isOverflow);
    }
  }, [texts]);

  return (
    <>
      <Header style={{ color: "var(--primary-theme-color)" }}>Broadcast Message View</Header>

      <Segment style={{ border: "solid 1px var(--primary-theme-color)" }}>
        {/* Text Section */}
        <div
          style={{
            backgroundColor: "var(--primary-select-background)",
            padding: 10,
            minHeight: "50px",
          }}
        >
          <div
            ref={textRef}
            style={{
              display: "-webkit-box",
              WebkitLineClamp: MAX_LINES,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              fontSize: 12,
              lineHeight: "20px",
              whiteSpace: "pre-wrap",
            }}
          >
            {texts}
          </div>

          {isClamp && (
            <span
              style={{
                color: "blue",
                fontSize: "12px",
              }}
            >
              See more
            </span>
          )}

          {/* Image Section */}
          {images.length > 0 && (
            <div
              style={{
                marginTop: 16,
                display: "grid",
                gridTemplateColumns: images.length === 1 ? "1fr" : "1fr 1fr",
                gap: 8,
              }}
            >
              {images.slice(0, 2).map((src, i) => (
                <div
                  key={i}
                  style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    overflow: "hidden",
                    borderRadius: 8,
                  }}
                >
                  <img
                    src={src}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {videos.length > 0 && (
          <div style={{ marginTop: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
            {videos.slice(0, 1).map((src, i) => (
              <div
                key={i}
                style={{
                  width: "100%",
                  aspectRatio: "16 / 9",
                  backgroundColor: "#000",
                  borderRadius: 8,
                  overflow: "hidden",
                }}
              >
                <iframe
                  title={i.toString()}
                  src={src}
                  frameBorder="0"
                  allowFullScreen
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            ))}
          </div>
        )}
      </Segment>
    </>
  );
};

export default BroadcastPreview;
